import useAuthorizationStep from './useAuthorizationStep';

export default useAuthorizationStep;
